import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchUpdateTemporarySearchFields,
} from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateTemporarySearchFields";
import customClearOrderHistoryFilter from "@tKgpco/Store/Data/OrderHistory/Handler/CustomClearOrderHistoryFilters";

addToChainBefore(chain, DispatchUpdateTemporarySearchFields, props => {
    const getOrderHistoryParams = props.getState().pages.orderHistory.getOrdersParameter;
    props.dispatch(customClearOrderHistoryFilter({ clearOrderHistoryFilters: false, getOrderHistoryParams }));
});
